"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.ListArticle = ListArticle;
exports.UpdateArticle = UpdateArticle;
exports.UpdateStatus = UpdateStatus;
exports.bindSpuLabelList = bindSpuLabelList;
exports.bindTagByCode = bindTagByCode;
exports.bindTagProduct = bindTagProduct;
exports.deleteTagBind = deleteTagBind;
exports.getDetail = getDetail;
exports.tagProductList = tagProductList;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    labelName = _ref.labelName,
    page = _ref.page,
    limit = _ref.limit,
    status = _ref.status;
  var data = {
    labelName: labelName,
    page: page,
    limit: limit,
    status: status
  };
  // return request({
  //     url: '/admin/store/label/list',
  //     method: 'GET',
  //     params: data,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/label/list',
    method: 'POST',
    data: data
  });
}
var handSubmit = function handSubmit() {
  var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var status = datas.status,
    labelName = datas.labelName,
    isHome = datas.isHome,
    _datas$scope = datas.scope,
    scope = _datas$scope === void 0 ? [] : _datas$scope,
    backgroundImage = datas.backgroundImage;
  var scopeValue = Array.isArray(scope) ? scope.join(',') : scope || '1';
  return {
    status: status,
    labelName: labelName,
    isHome: isHome || 0,
    scope: scopeValue,
    productSource: 1,
    backgroundImage: backgroundImage
  };
};

/**
 * 新增
 * @param pram
 * @constructor
 */
function AddArticle(pram) {
  // return request({
  //     url: '/admin/store/label/save',
  //     method: 'post',
  //     data: handSubmit(pram),
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/label/add',
    method: 'post',
    data: handSubmit(pram)
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
function UpdateArticle(pram) {
  // return request({
  //     url: '/admin/store/label/update',
  //     method: 'post',
  //     data: {...handSubmit(pram), id: pram.id },
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/label/update',
    method: 'post',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}

/**
 * 更新状态
 * @param pram
 * @constructor
 */
function UpdateStatus(pram) {
  // return request({
  //     url: '/admin/store/label/updateStatus',
  //     method: 'post',
  //     data: {...handSubmit(pram), id: pram.id },
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/label/updateStatus',
    method: 'post',
    data: {
      id: pram.id,
      status: pram.status
    }
  });
}

/**
 * 删除
 * @param id
 * @constructor
 */
function DelArticle(pram) {
  var data = {
    id: pram.id
  };
  // return request({
  //     url: `/admin/store/label/delete`,
  //     method: 'get',
  //     params: data,
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/product/label/del/".concat(pram.id),
    method: 'post',
    params: data
  });
}

/**
 * 详情
 * @param {*} id
 * @returns
 */
function getDetail(id) {
  // return request({
  //     url: `/admin/store/label/info`,
  //     method: 'get',
  //     params: { id },
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/product/label/get/".concat(id),
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 绑定产品
 * @param {*} data
 * @returns
 */
function bindTagProduct(data) {
  // return request({
  //     url: `/admin/store/label/bindProduct`,
  //     method: 'post',
  //     data
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/product/label/bindProduct",
    method: 'post',
    data: data
  });
}

/**
 * 删除绑定商品
 */
function deleteTagBind(data) {
  // return request({
  //     url: `/admin/store/label/deleteBindProduct`,
  //     method: 'post',
  //     data,
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/product/label/deleteBindProduct",
    method: 'post',
    data: data
  });
}

/**
 * 商品列表-绑定标签的
 * @param pram
 * @constructor
 */
function tagProductList() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = pram || {},
    labelId = _ref2.labelId,
    cateId = _ref2.cateId,
    productName = _ref2.productName,
    spuCode = _ref2.spuCode,
    spuId = _ref2.spuId,
    skuId = _ref2.skuId,
    page = _ref2.page,
    limit = _ref2.limit,
    type = _ref2.type,
    keyword = _ref2.keyword;
  var data = {
    labelId: labelId,
    cateId: cateId,
    productName: productName,
    spuCode: spuCode,
    spuId: spuId,
    skuId: skuId,
    page: page,
    limit: limit,
    type: type,
    keyword: keyword
  };
  // return request({
  //     url: '/admin/store/label/bind/list',
  //     method: 'GET',
  //     params: data,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/label/bind/list',
    method: 'POST',
    data: data
  });
}

/**
 * 导入绑定商品标签
 * @param {*} data
 * @returns
 */
function bindTagByCode(data) {
  var _ref3 = data || {},
    id = _ref3.id,
    type = _ref3.type,
    spuIdList = _ref3.spuIdList,
    productCodeList = _ref3.productCodeList,
    overwrite = _ref3.overwrite;
  // return request({
  //     url: `/admin/store/label/bindProductByCode`,
  //     method: 'post',
  //     data: {
  //         id,
  //         type,
  //         spuIdList: spuIdList || productCodeList,
  //         overwrite: overwrite ? 1 : 0,
  //     },
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/product/label/bindProductByCode",
    method: 'post',
    data: {
      id: id,
      type: type,
      spuIdList: spuIdList || productCodeList,
      overwrite: overwrite ? 1 : 0
    }
  });
}

/**
 * 根据spuId批量查询已绑定标签
 * @param {*} data
 * @returns
 */
function bindSpuLabelList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _data$spuIdList = data.spuIdList,
    spuIdList = _data$spuIdList === void 0 ? [] : _data$spuIdList;
  // return request({
  //     url: '/admin/store/label/bind/spu/label/list',
  //     method: 'post',
  //     data: { spuIdList },
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/label/bind/spu/label/list',
    method: 'post',
    data: {
      spuIdList: spuIdList
    }
  });
}